// BrHeaderDrawer: HeaderDrawer を拡張してドロワー・overlayをbody直下で管理する
// global.js の HeaderDrawer が定義された後に実行する必要があるため defer で読み込む

(function () {
  function init() {
    var headerDrawerEl = document.querySelector('header-drawer');
    if (!headerDrawerEl) return;

    var drawer = document.getElementById('menu-drawer');
    var details = document.getElementById('Details-menu-drawer-container');
    if (!drawer || !details) return;

    // ── ① bfcache / ブラウザ状態復元で details が open になっている場合を強制リセット ──
    details.removeAttribute('open');
    details.classList.remove('menu-opening');

    // ── ② ドロワーを body 直下に移植 ──────────────────────────────
    // 移植後も details との親子関係が必要なため、
    // ダミーのプレースホルダーを元の場所に残し、
    // ドロワーを body 直下に移動する
    var placeholder = document.createComment('menu-drawer moved to body');
    drawer.parentNode.replaceChild(placeholder, drawer);
    document.body.appendChild(drawer);

    // ── ② <main> 直前の PageOverlay を取得 ──────────────────────────
    var overlay = document.querySelector('.PageOverlay');

    if (overlay) {
      overlay.addEventListener('click', function () {
        var summary = headerDrawerEl.querySelector('summary');
        if (summary) summary.click();
      });
    }

    // ── ③ × ボタンをドロワー内に追加 ─────────────────────────────
    var closeBtn = document.createElement('button');
    closeBtn.className = 'br-drawer-close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" aria-hidden="true" focusable="false">',
      '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351',
      'L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L9.005 7.838 1.413.342a.5.5 0 10-.707.708l7.592 7.545-7.433 7.383z"/>',
      '</svg>',
    ].join('');
    closeBtn.addEventListener('click', function () {
      var summary = headerDrawerEl.querySelector('summary');
      if (summary) summary.click();
    });

    var innerContainer = drawer.querySelector('.menu-drawer__inner-container');
    if (innerContainer) innerContainer.insertBefore(closeBtn, innerContainer.firstChild);

    // ── ④ transitionを有効化（ページロード時の閉じアニメ防止のため遅延付与）──
    // rAF を2回挟むことでレイアウト確定後に付与し、初期フレームのアニメを抑制する
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('br-ready');
      });
    });

    // ── ⑤ Shopify の menu-opening クラスを監視して overlay / drawer を同期 ──
    // Shopify の global.js は details に open 属性と menu-opening クラスを付与する。
    // ドロワーが body 直下に移動したため details[open] > .menu-drawer セレクタが
    // 機能しなくなるので、クラスで制御する。
    var rafId = null;

    function sync() {
      var isOpening = details.classList.contains('menu-opening');
      var isOpen = details.hasAttribute('open');

      // ドロワー表示制御
      if (isOpen && isOpening) {
        drawer.classList.add('br-is-open');
      } else {
        drawer.classList.remove('br-is-open');
      }

      // overlay 表示制御
      if (overlay) {
        if (isOpening) {
          overlay.classList.add('is-visible');
        } else {
          overlay.classList.remove('is-visible');
        }
      }
    }

    var observer = new MutationObserver(function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(sync);
    });

    observer.observe(details, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });
  }

  // global.js の HeaderDrawer 定義後（defer）に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // bfcache から復元された場合もドロワーをリセット
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var details = document.getElementById('Details-menu-drawer-container');
    var drawer = document.getElementById('menu-drawer');
    if (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    }
    if (drawer) {
      drawer.classList.remove('br-is-open');
    }
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');
  });
})();
